@if (isVisible$ | async) {
  @if (entity(); as shopEntity) {
    <app-push-shop-card-v2-atom
      [entity]="shopEntity"
      [title]="title()"
      [category]="categoryLabel()"
      [shortDescription]="shopEntity[entityKeys.ShortDescription] ?? ''"
      [categoryBadge]="getCategoryBadge(shopEntity)"
      [imgUrl]="image()?.url ?? shopImage ?? ''"
      [linkUrl]="getEntityUrl(shopEntity)"
      [address]="getEntityAddress(shopEntity)"
      [displayEntityName]="displayEntityName()"
      [displayEntityImage]="displayEntityImage()"
      [displayEntityDistance]="displayEntityDistance()"
      [displayEntityPricing]="displayEntityPricing()"
      [displayEntityAddress]="displayEntityAddress()"
      [displayEntityCategory]="displayEntityCategory()"
      [entityNameSize]="entityNameSize()"
      [entityNameColor]="entityNameColor()"
      [kioskCardAspectRatio]="kioskCardAspectRatio()"
      [templateLayout]="templateLayout()"
      [preserveImageDimensions]="preserveImageDimensions()"
      [imageBackgroundColor]="imageBackgroundColor()"
    ></app-push-shop-card-v2-atom>
  }
}
